module.exports = __webpack_public_path__ + "img/icon_ac01.844a25c1.png";